import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Thank you page displayed after logout
 */
const ThankYouPage = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow-sm">
            <div className="card-body text-center p-5">
              <div className="mb-4">
                <i className="fas fa-heart text-danger heart-pulse" style={{ fontSize: '4rem' }}></i>
              </div>
              <h2 className="mb-3">Thank you for using Ankr</h2>
              <p className="lead mb-4">Hope you feel better soon.</p>
              <p className="text-muted mb-4">Your session has been ended securely.</p>
              <Link to="/" className="btn btn-primary">
                <i className="fas fa-home me-2"></i>
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;